var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1687762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.59763 24.5976C10.2414 24.5976 13.1953 21.6438 13.1953 18C13.1953 14.3562 10.2414 11.4024 6.59763 11.4024C2.95386 11.4024 0 14.3562 0 18C0 21.6438 2.95386 24.5976 6.59763 24.5976Z",
    fill: "#0000D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.3375 14.6948C27.9199 14.6948 28.3922 14.2225 28.3922 13.6401C28.3922 13.0576 27.9199 12.5854 27.3375 12.5854H25.0781C24.4957 12.5854 24.0234 13.0576 24.0234 13.6401V22.0776C24.0234 22.66 24.4957 23.1323 25.0781 23.1323H27.3375C27.9199 23.1323 28.3922 22.66 28.3922 22.0776C28.3922 21.4951 27.9199 21.0229 27.3375 21.0229H26.1328V18.9135H27.3375C27.9199 18.9135 28.3922 18.4413 28.3922 17.8588C28.3922 17.2764 27.9199 16.8041 27.3375 16.8041H26.1328V14.6948H27.3375Z",
    fill: "#0000D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.9452 21.3053C33.658 21.3053 32.6108 20.258 32.6108 18.9709V17.0291C32.6108 15.7419 33.6581 14.6948 34.9452 14.6948C35.5277 14.6948 35.9999 14.2225 35.9999 13.6401C35.9999 13.0576 35.5277 12.5854 34.9452 12.5854C32.4949 12.5854 30.5015 14.5789 30.5015 17.0291V18.9709C30.5015 21.4212 32.495 23.4146 34.9452 23.4146C35.5277 23.4146 35.9999 22.9424 35.9999 22.36C35.9999 21.7775 35.5277 21.3053 34.9452 21.3053Z",
    fill: "#0000D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7671 12.5854H16.3594C15.7769 12.5854 15.3047 13.0576 15.3047 13.6401V22.0776C15.3047 22.66 15.7769 23.1323 16.3594 23.1323C16.9418 23.1323 17.4141 22.66 17.4141 22.0776V20.169L19.7982 22.7877C20.0063 23.0162 20.2919 23.1323 20.5784 23.1323C20.8318 23.1323 21.0861 23.0415 21.2882 22.8575C21.7189 22.4654 21.7502 21.7983 21.358 21.3676L19.6987 19.545C19.9803 19.3878 20.2432 19.1957 20.4804 18.9699C21.2128 18.2744 21.6329 17.3065 21.6329 16.3143V16.313C21.6328 14.2576 19.8986 12.5854 17.7671 12.5854ZM17.4141 14.6948H17.7671C18.7355 14.6948 19.5234 15.4207 19.5234 16.313V16.3143C19.5234 16.7369 19.3474 17.1367 19.0268 17.4412C18.6979 17.7543 18.2382 17.9338 17.7656 17.9338H17.414V14.6948H17.4141Z",
    fill: "#0000D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.f4cc32a1a8f08b93825fe055e63a9860.svg";
export { ForwardRef as ReactComponent };